import SalaryPageTemplate from "@/components/SalaryPageTemplate";
import { SALARY_DATA } from "@/data/salaryData";

export default function SoftwareEngineerSalary() {
  return <SalaryPageTemplate data={SALARY_DATA["software-engineer"]} />;
}
